import { gql } from 'graphql-request'

export default gql `
  query customApplications($date: String!, $pwbusId: String!, $userCode: String!, $reportCode: String, $debugMode: String) {
    applications {
      paymentDemonstrative {
        reportsPerMonth(
          date: $date
          userCode: $userCode
          pwbusCorrelationId: $pwbusId
          reportCode: $reportCode
          debugMode: $debugMode
        ) {
          success
          pwbus_correlation_id
          pdf_report
          xls_report
          xml_report
          xml_report_exchange
          report_code
        }
      }
    }
  }
`